var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEtapa5Icon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5.8125V0.5H0.9375C0.677083 0.5 0.455729 0.591146 0.273438 0.773438C0.0911458 0.955729 0 1.17708 0 1.4375V19.5625C0 19.8229 0.0911458 20.0443 0.273438 20.2266C0.455729 20.4089 0.677083 20.5 0.9375 20.5H14.0625C14.3229 20.5 14.5443 20.4089 14.7266 20.2266C14.9089 20.0443 15 19.8229 15 19.5625V6.75H9.6875C9.42708 6.75 9.20573 6.65885 9.02344 6.47656C8.84115 6.29427 8.75 6.07292 8.75 5.8125ZM15 5.26562V5.5H10V0.5H10.2344C10.4948 0.5 10.7161 0.591146 10.8984 0.773438L14.7266 4.60156C14.9089 4.78385 15 5.00521 15 5.26562Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtapa5Icon);
export default __webpack_public_path__ + "static/media/etapa-5-icon.5c0ca5f8c6932f1bda7c10cb7581124c.svg";
export { ForwardRef as ReactComponent };